import React from "react";
import {
    AiFillGithub,
    AiFillInstagram,
    AiOutlineLinkedin,
    AiOutlineArrowUp,
} from "react-icons/ai";

const Footer = () => {
    return (
        <footer>
            <div>
                <img
                    src={"https://images.unsplash.com/photo-1575936123452-b67c3203c357?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D&w=1000&q=80"}
                    alt="Founder"
                />

                <h2>SATYAM SRIVASTAVA</h2>
                <p>Motivation is temporary, but discipline last forever.</p>
            </div>

            <aside>
                <h2>Social Media</h2>

                <article>
                    <a href="https://www.linkedin.com/in/satyam-srivastava-coder/" target={"blank"}>
                        <AiOutlineLinkedin />
                    </a>
                    <a href="https://www.instagram.com/satyam_384/" target={"blank"}>
                        <AiFillInstagram />
                    </a>
                    <a href="https://github.com/lieftsatyamShrivastava" target={"blank"}>
                        <AiFillGithub />
                    </a>
                </article>
            </aside>
            <a href="#home">
                <AiOutlineArrowUp />
            </a>
        </footer>
    );
};

export default Footer;